import i from "styled-components";
import { Icon as a } from "./atoms-v217.js";
import { Button as c } from "./atoms-v2777.js";
import { breakpoints as d } from "./atoms-v2125.js";
const n = "cubic-bezier(0, 0, 0.3, 1)", r = "cubic-bezier(0.4, 0.14, 1, 1)", s = "240ms", e = i.button`
  ${c}

  ${({ theme: o }) => {
  var t;
  return (t = o == null ? void 0 : o.get("tokens.body.compact-expressive")) == null ? void 0 : t.toJS();
}}

  align-items: center;
  background-color: transparent;
  border-top: solid 1px ${({ theme: o }) => o == null ? void 0 : o.get("tokens.border.light.light")};
  color: inherit;
  column-gap: 24px;
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: space-between;
  padding: 0 12px;
  text-align: left;

  &[disabled] {
    color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.disabled")};
    cursor: default;
  }

  &:hover {
    background-color: ${({ theme: o }) => o == null ? void 0 : o.get("ui.accordion.light.hover")};
  }

  &:focus-visible {
    outline: 1px solid ${({ theme: o }) => o == null ? void 0 : o.get("ui.accordion.light.focus")};
  }

  @media ${d.small} {
    ${({ theme: o }) => {
  var t;
  return (t = o == null ? void 0 : o.get("tokens.body.compact-productive")) == null ? void 0 : t.toJS();
}}
  }
`, b = i(a)`
  transform: ${({ $isOpen: o }) => o ? "rotate(-180deg)" : "rotate(0)"};
  transition-duration: ${s};
  transition-property: transform;
  transition-timing-function: ${({ $isOpen: o }) => o ? n : r};
`, f = i.div`
  box-sizing: border-box;
  height: ${({ $isOpen: o }) => o ? "auto" : "0"};
  opacity: ${({ $isOpen: o }) => o ? 1 : 0};
  overflow: hidden;
  padding: ${({ $isOpen: o }) => o ? "8px 12px 24px" : "0"};
  pointer-events: ${({ $isOpen: o }) => o ? "auto" : "none"};
  transform: ${({ $isOpen: o }) => o ? "translate3d(0, 0, 0)" : "translate3d(0, -12px, 0)"};
  transition-duration: ${s};
  transition-property: opacity, transform;
  transition-timing-function: ${({ $isOpen: o }) => o ? n : r};
`, x = i.div`
  display: flex;
  flex-direction: column;
`;
export {
  x as AccordionItem,
  f as Content,
  b as Disclosure,
  e as Toggle
};
